export const KUBERA_AI_SYNC_CHROME_STORE_URL =
  "https://chromewebstore.google.com/detail/kubera-ai-sync/jacbloogjhbhilldkncmcmgnnoipdfmn";

export const KUBERA_AI_SYNC_HELP_URL =
  "https://help.kubera.com/article/169-ai-sync-sync-assets-debts-and-cash-flow-from-a-webpage";

export const KUBERA_WEB_SYNC_AI_ASSISTANT_HELP_URL =
  "https://help.kubera.com/article/179-sync-accounts-using-your-ai-assistant";
